/** Native scroll snapping keeps swipe navigation usable without JavaScript. */
class IonicColorGallery extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.track = this.querySelector('.ionic-color-gallery__track');
    this.slides = [...this.querySelectorAll('[data-gallery-image]')];
    this.thumbs = [...this.querySelectorAll('[data-gallery-index]')];
    this.dialog = this.querySelector('dialog');
    this.index = 0;
    this.addEventListener('click', (event) => {
      const target = event.target.closest('button, [data-gallery-image]');
      if (!target) return;
      if (target.hasAttribute('data-gallery-step')) this.select(this.index + Number(target.dataset.galleryStep));
      if (target.hasAttribute('data-gallery-index')) this.select(Number(target.dataset.galleryIndex));
      if (target.hasAttribute('data-gallery-close')) this.dialog.close();
      if (target.hasAttribute('data-gallery-image')) {
        event.preventDefault();
        this.zoomTrigger = target;
        const image = this.querySelector('[data-gallery-zoom-image]');
        image.src = target.href;
        image.alt = target.querySelector('img').alt;
        this.dialog.showModal();
      }
    }, options);
    this.track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      this.select(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
    }, options);
    this.track.addEventListener('scroll', () => {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.update());
    }, { ...options, passive: true });
    this.dialog.addEventListener('close', () => this.zoomTrigger?.focus({ preventScroll: true }), options);
    this.update();
  }
  disconnectedCallback() {
    this.controller?.abort();
    cancelAnimationFrame(this.frame);
    if (this.dialog?.open) this.dialog.close();
  }
  select(index) {
    const next = Math.max(0, Math.min(this.slides.length - 1, index));
    this.track.scrollTo({ left: next * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }
  update() {
    this.index = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
    this.querySelector('[data-gallery-count]').textContent = (this.index + 1) + ' / ' + this.slides.length;
    this.thumbs.forEach((thumb, index) => {
      if (index === this.index) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
    this.querySelector('[data-gallery-step="-1"]').disabled = this.index === 0;
    this.querySelector('[data-gallery-step="1"]').disabled = this.index === this.slides.length - 1;
  }
}
if (!customElements.get('ionic-color-gallery')) customElements.define('ionic-color-gallery', IonicColorGallery);
